import React, { createContext, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./custom-toast.css"

// Création du contexte
const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  // Fonction pour afficher une notification
  const showToast = (message, type = "info", options = {}) => {
    const { autoClose = 5000, position = "top-right", ...restOptions } = options || {};

    toast(message, {
      type,
      position,
      autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      className: "custom-toast", // Classe personnalisée gérée par le context
      ...restOptions,
    });
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
};

// Hook personnalisé pour accéder au ToastContext
export const useToast = () => useContext(ToastContext);